var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.legends),function(legend){return _c('ChartLegend',{key:legend.color,attrs:{"legend":legend}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }